import { DiscountType, Product, ProductVariation, ToppingValueDto } from "../";

export const getVariantByToppings = (
  productToppingVariations: ProductVariation[],
  toppings: ToppingValueDto[],
) => {
  return productToppingVariations.find((variant) => {
    let find = true;
    toppings.forEach((topping) => {
      if (
        !variant.variations?.find(
          (value) =>
            value.toppingId === topping.toppingId &&
            value.value === topping.value,
        )
      )
        find = false;
    });
    return find;
  });
};

export const priceCalculator = (
  product: Product,
  toppings?: ToppingValueDto[],
  quantity?: number,
  fullPrice?: boolean,
): number => {
  let calculatedPrice =
    (fullPrice
      ? product?.price
      : product?.priceWithDiscount || product?.price) || 0;
  let toppingsPrice = 0;

  if (product.productToppingVariations) {
    const variant = getVariantByToppings(
      product.productToppingVariations,
      toppings || [],
    );
    calculatedPrice =
      (fullPrice
        ? variant?.price
        : variant?.priceWithDiscount || variant?.price) || 0;
  } else {
    toppingsPrice =
      toppings?.reduce((previousValue, currentValue) => {
        return (
          previousValue +
          (product?.percentageDiscount
            ? currentValue.additionalPrice *
              ((100 - product?.percentageDiscount) / 100)
            : currentValue.additionalPrice)
        );
      }, 0) || 0;
  }

  return quantity
    ? toppingsPrice
      ? (Math.abs(calculatedPrice) + toppingsPrice) * quantity
      : Math.abs(calculatedPrice) * quantity
    : toppingsPrice
    ? Math.abs(calculatedPrice) + toppingsPrice
    : Math.abs(calculatedPrice);
};

export const priceWithWholesale = (
  product: Product,
  toppings?: ToppingValueDto[],
) => {
  const variant = getVariantByToppings(
    product.productToppingVariations || [],
    toppings || [],
  );
  const wholesaleConfig =
    product?.wholesale?.configurations || variant?.wholesale?.configurations;

  if (wholesaleConfig) {
    return (wholesaleConfig || []).reduce((p, n) => {
      const calculatedPrice = priceCalculator(product, toppings, 1);
      let value = 0;
      if (n.discountType === DiscountType.percentage) {
        value = calculatedPrice - (calculatedPrice * n.unitPrice) / 100;
      } else {
        value = n.unitPrice;
      }
      return p + value;
    }, 0);
  }
  return;
};
